<form [formGroup]="createForm" (ngSubmit)="onSubmit()" class="form-validation">
  <div class="modal-header">
    <h4 class="modal-title pull-left" style="text-transform: uppercase;">Create New Event</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="row">

      <ng-template #ErrorMsg let-msg="msg" let-value="value" let-submitted="submitted">
        <div *ngFor="let validation of msg">
          <div class="error-message"
            *ngIf="value.hasError(validation.type) && (value.touched || value.dirty || submitted)">
            {{validation.message}}
          </div>
        </div>
      </ng-template>

      <div class="form-group col-sm-12">
        <label for="first-name">{{ langs?.date }}</label>
        <input type="date" class="form-control" formControlName="date_event"
          [ngClass]="formErrorClass(createForm.controls.date_event, createFormSubmitted)">
        <ng-template [ngTemplateOutlet]="ErrorMsg"
          [ngTemplateOutletContext]="{msg:createFormErrorMsg.date_event, value:createForm.controls.date_event, submitted:createFormSubmitted }">
        </ng-template>
      </div>


      <div class="form-group col-sm-12">
        <label for="first-name">{{ langs?.title }}</label>
        <input type="text" class="form-control" formControlName="title_event"
          [ngClass]="formErrorClass(createForm.controls.title_event, createFormSubmitted)">
        <ng-template [ngTemplateOutlet]="ErrorMsg"
          [ngTemplateOutletContext]="{msg:createFormErrorMsg.title_event, value:createForm.controls.title_event, submitted:createFormSubmitted }">
        </ng-template>
      </div>

      <div class="form-group col-sm-12">
        <label for="first-name">{{ langs?.description }}</label>
        <textarea type="text" class="form-control" formControlName="des_event"
          [ngClass]="formErrorClass(createForm.controls.des_event, createFormSubmitted)"></textarea>
        <ng-template [ngTemplateOutlet]="ErrorMsg"
          [ngTemplateOutletContext]="{msg:createFormErrorMsg.des_event, value:createForm.controls.des_event, submitted:createFormSubmitted }">
        </ng-template>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="submit" class="btn btn-success">{{ langs?.submit }}</button>
    <button type="button" class="btn btn-warning" (click)="bsModalRef.hide()">{{ langs?.close }}</button>

  </div>
</form>